import styled from "@emotion/styled"

export const Wrapper = styled.div`
  position: relative;
  ::before {
    content: "";
    position: absolute;
    inset: 0;
    background-size: 600px auto;
    background-repeat: repeat;
    background-image: url(${({ bgimage }) => bgimage});
  }
`
